import {useCallback, useState} from 'react';
import AuthCode from 'react-auth-code-input';
import {useTranslation} from 'react-i18next';

import {userApi} from 'api';
import {Button, DataWrapper, notifier} from 'components';
import {PASSWORD_CHANGE} from 'constants/images';
import {useApiData} from 'hooks';
import {TRANSLATION_KEYS} from 'locale';
import {AuthData} from 'types';
import {apiUtils} from 'utils';

const COMMON_T_KEYS = TRANSLATION_KEYS.COMMON;
const T_KEYS = TRANSLATION_KEYS.USER.MFA_CONFIRM;

const LENGTH = 6;

type Props = {
    accessToken: string;
    onCancel: () => void;
    onSuccess: (authData: AuthData) => void;
}

export const MfaVerifyEmail: React.FC<Props> = ({accessToken, onCancel, onSuccess}) => {
    const {t} = useTranslation();
    const [code, setCode] = useState('');

    const onError = useCallback((error) => {
        const data = apiUtils.getValidationErrors(error);
        if (data?.errors?.code) {
            notifier.error({details: t(T_KEYS.INVALID_OTP)});
        } else {
            notifier.error({details: t(COMMON_T_KEYS.MESSAGES.ERROR.UNEXPECTED)});
        }
    }, [t]);

    const {send} = useApiData(userApi.verifyMfaEmail, {onSuccess, onError});

    const submit = useCallback(() => {
        send(accessToken, +code);
    }, [send, accessToken, code]);

    return (
        <DataWrapper>
            <img src={PASSWORD_CHANGE} alt={t(T_KEYS.DESCRIPTION)} className='tw-mx-auto tw-mb-8' />
            <div className='tw-text-default tw-text-center tw-mb-8'>{t(T_KEYS.DESCRIPTION)}</div>
            <AuthCode
                allowedCharacters='numeric'
                length={LENGTH}
                containerClassName='tw-text-center'
                inputClassName='tw-w-8 tw-h-10 tw-mx-1 tw-border tw-text-lg tw-border-default tw-rounded-lg tw-text-center'
                onChange={setCode}
            />
            <div className='tw-flex -sm:tw-flex-col tw-justify-center tw-mt-8'>
                <Button className='-sm:tw-mb-4 sm:tw-mr-4' onClick={onCancel}>{t(COMMON_T_KEYS.BUTTONS.CANCEL)}</Button>
                <Button
                    color='primary'
                    disabled={code.length < LENGTH}
                    onClick={submit}
                >
                    {t(COMMON_T_KEYS.BUTTONS.OK)}
                </Button>
            </div>
        </DataWrapper>
    );
};